module.exports = __webpack_public_path__ + "linkedin-049a282f.png";